import { formatPrice } from '../../utils/formatPrice';
import { getProductImage } from '../../utils/imageHelper';
import { Button } from './Button';
import { Trash2, Minus, Plus } from 'lucide-react';

export function CartItem({ item, onUpdateQuantity, onRemove }) {
  const itemTotal = item.price * item.quantity;

  return (
    <div className="flex gap-4 p-4 bg-gray-50 rounded-xl">
      <div className="relative w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden bg-white">
        <img 
          src={getProductImage(item.image)} 
          alt={item.name} 
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="flex-1 min-w-0 flex flex-col justify-between">
        <div>
          <div className="flex items-center justify-between gap-1">
            <h4 className="font-bold text-gray-900 text-sm truncate">{item.name}</h4>
            {item.size && (
              <span className="text-[10px] text-gray-500 bg-white px-1.5 py-0.5 rounded border border-gray-200 flex-shrink-0">
                {item.size}
              </span>
            )}
          </div>
          {item.nameUrdu && (
            <p className="font-urdu text-primary text-xs font-semibold" dir="rtl">{item.nameUrdu}</p>
          )}
          {item.packageItems && item.packageItems.length > 0 ? (
            <div className="mt-1 mb-1 p-1.5 bg-emerald-50 rounded-lg border border-emerald-100">
              <span className="text-[10px] font-bold text-emerald-800 block mb-0.5">🎁 Includes 5 Full Items:</span>
              <p className="text-[10px] text-emerald-700 leading-tight">
                {item.packageItems.map(p => p.name).join(' • ')}
              </p>
            </div>
          ) : item.descriptionUrdu && (
            <p className="font-urdu text-gray-600 text-[11px] line-clamp-1 mt-0.5" dir="rtl">{item.descriptionUrdu}</p>
          )}
          <p className="text-primary font-bold text-sm mt-1">{formatPrice(item.price)}</p>
        </div>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 bg-white rounded-lg border border-gray-200">
            <button
              onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
              className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-l-lg transition-colors"
              aria-label="Decrease quantity"
            >
              <Minus className="w-4 h-4" />
            </button>
            <span className="px-3 text-center font-medium w-10">{item.quantity}</span>
            <button
              onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
              className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-r-lg transition-colors"
              aria-label="Increase quantity"
            >
              <Plus className="w-4 h-4" />
            </button>
          </div>
          
          <div className="flex items-center gap-3">
            <span className="font-bold text-gray-900">{formatPrice(itemTotal)}</span>
            <button
              onClick={() => onRemove(item.id)}
              className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
              aria-label="Remove item"
            >
              <Trash2 className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}